import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {filter, map} from 'rxjs/operators';
import {environment} from "../../environments/environment";
import {AccountService} from "../core/auth/account.service";
import {IEj} from "../../shared/model/ej.model";
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import Utils from "../utils/utils";
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-mandat-redirect',
    templateUrl: './mandat-redirect.component.html',
    styleUrls: ['./mandat-redirect.component.css'],
    imports: [MatCard, MatCardTitle, MatProgressSpinner, MatCardContent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, MatButton]
})
export class MandatRedirectComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private http = inject(HttpClient);
  private accountService = inject(AccountService);
  private fb = inject(UntypedFormBuilder);
  private router = inject(Router);

  isLoading = true;
  apiUrl = environment.apiUrl;
  params: Params;
  typeReturn: string;
  sessionIdReturn: string;
  type: string;
  otherEjs = false;
  MANDAT_STATUS_WAIT = 'En attente';
  MANDAT_STATUS_SIGN = 'Signé';
  MANDAT_STATUS_CANCEL = 'Abandon';
  MANDAT_STATUS_ERROR = 'Erreur';
  MANDAT_STATUS_ERROR_TECHNIQUE = 'Erreur technique';
  MANDAT_SESSION_EXPIRED = 'Session expirée';

  form: UntypedFormGroup = this.fb.group({
    password: ['', [Validators.required, Validators.minLength(8)]],
    passwordConfirm: ['', [Validators.required]]
  }, {
    validator: Utils.passwordMatchValidator
  });

  password = "";

  constructor() {
    this.route.params.subscribe((params) => {
      this.params = params;
    });
  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe((paramsUrl: Params) => {
        if (typeof paramsUrl.SessionId === "string") {
          this.sessionIdReturn = paramsUrl.SessionId;
          }
        }
      );

    if (this.sessionIdReturn == null) {
      this.type = this.route.snapshot.paramMap.get('type');
      if (this.type === "uncompleted") {
        this.typeReturn = "uncompleted";
      } else {
        this.typeReturn = "error";
      }
      this.isLoading = false;
    } else {
      this.http.get(this.apiUrl + '/mandat/retrieve/' + this.sessionIdReturn, {
        observe: 'response',
        responseType: 'text'
      }).pipe(
        filter((res: HttpResponse<string>) => res.ok),
        map((res: HttpResponse<string>) => res.body)
      ).subscribe((statusMandat: string) => {
          switch (statusMandat) {
            case this.MANDAT_STATUS_WAIT:
              this.typeReturn = 'error';
              break;
            case this.MANDAT_STATUS_CANCEL:
              this.typeReturn = 'canceled';
              break;
            case this.MANDAT_STATUS_ERROR:
              this.typeReturn = 'failure';
              break;
            case this.MANDAT_STATUS_ERROR_TECHNIQUE:
              this.typeReturn = 'error';
              break;
            case this.MANDAT_STATUS_SIGN:
              this.typeReturn = 'validate';
              break;
            case this.MANDAT_SESSION_EXPIRED:
              this.typeReturn = 'expired';
              break;
            default:
              this.typeReturn = 'expired';
              break;
          }
          this.loadEjs();
          this.isLoading = false;
        },
        () => {
          this.typeReturn = "error";
          this.isLoading = false;
        }
      );
    }
  }

  private loadEjs(): void {
    this.accountService.fetchEjs().then((value: IEj[]) => {
      this.otherEjs = value.length > 0;
    });
  }
  activatedAccount(): boolean {
    return (localStorage.getItem('activated') != null ? localStorage.getItem('activated') === 'true' : false) || this.params.type == 'uncompleted-activate';
  }

  setPassword(): void {
    this.http.post(this.apiUrl + '/user/password', this.password)
      .subscribe(() => {
        localStorage.removeItem('activated');
          /* eslint @typescript-eslint/no-unsafe-member-access: 0 */
          /* eslint @typescript-eslint/no-unsafe-assignment: 0 */
        const token = localStorage.getItem('accessToken');
        const jsonParseToken = JSON.parse(atob(token.split('.')[1]));
        const email = jsonParseToken.sub as string;
        localStorage.setItem('email', email);
        if (jsonParseToken.provider !== undefined) {
          localStorage.setItem('provider', jsonParseToken.provider as string);
        }
        this.router.navigate(['switch-company']);
      });
  }
}
